
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M18 8.3C18 11.7794 15.4286 15.4 12 19C8.57143 15.4 6 11.7794 6 8.3C6 4.82061 8.68629 2 12 2C15.3137 2 18 4.82061 18 8.3ZM14 8C14 9.10457 13.1046 10 12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M7.12911 19.4684C7.1185 19.4761 7.10858 19.4836 7.09931 19.4907C7.27932 19.6299 7.59682 19.7973 8.07359 19.9563C9.03245 20.2759 10.4207 20.4907 12 20.4907C13.5793 20.4907 14.9675 20.2759 15.9264 19.9563C16.4032 19.7973 16.7207 19.6299 16.9007 19.4907C16.8959 19.487 16.8909 19.4832 16.8857 19.4793C16.8809 19.4758 16.876 19.4721 16.8709 19.4684C16.6514 19.3083 16.2704 19.1242 15.7141 18.9583L16.2859 17.0417C16.9571 17.242 17.5761 17.5071 18.0497 17.8527C18.5033 18.1837 19 18.7256 19 19.4907C19 20.2046 18.5651 20.7255 18.1475 21.0546C17.7186 21.3926 17.16 21.6533 16.5589 21.8536C15.3462 22.2579 13.7344 22.4907 12 22.4907C10.2656 22.4907 8.65384 22.2579 7.44113 21.8536C6.84 21.6533 6.2814 21.3926 5.85254 21.0546C5.43495 20.7255 5 20.2046 5 19.4907C5 18.7256 5.49672 18.1837 5.95027 17.8527C6.42393 17.5071 7.04291 17.242 7.71411 17.0417L8.28589 18.9583C7.72959 19.1242 7.34857 19.3083 7.12911 19.4684ZM6.97461 19.6104C6.97435 19.6104 6.97557 19.6079 6.97901 19.6031C6.97658 19.608 6.97486 19.6104 6.97461 19.6104ZM17.0254 19.6104C17.0251 19.6104 17.0234 19.608 17.021 19.6031C17.0244 19.6079 17.0256 19.6104 17.0254 19.6104Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowSelectlocationFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
